import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "name"
};
var _hoisted_2 = {
  key: 0,
  "class": "edit-h5-header"
};
var _hoisted_3 = {
  "class": "left"
};
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = {
  key: 1,
  "class": "edit-h5-footer"
};
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { watchEffect, ref, nextTick } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import editIcon from "../../../assets/icon/edit.svg";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import { isPC, isUniFrameWork } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-name',
  props: {
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    isAuthor: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["update"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var groupProfile = ref({});
    var inputGroupName = ref("");
    var isEdit = ref(false);
    var nameInputRef = ref(null);
    watchEffect(function () {
      groupProfile.value = props.data;
    });
    var emit = __emit;
    var updateProfile = function updateProfile() {
      if (!inputGroupName.value) {
        Toast({
          message: TUITranslateService.t("TUIGroup.群名称不能为空"),
          type: TOAST_TYPE.ERROR
        });
      } else {
        if (inputGroupName.value !== groupProfile.value.name) {
          emit("update", {
            key: "name",
            value: inputGroupName.value
          });
          groupProfile.value.name = inputGroupName.value;
          inputGroupName.value = "";
          Toast({
            message: TUITranslateService.t("TUIGroup.群名称修改成功"),
            type: TOAST_TYPE.SUCCESS
          });
        }
        close();
      }
    };
    var close = function close() {
      if (props.isAuthor) {
        isEdit.value = !isEdit.value;
        // 只有 pc 会有这样的情况
        isPC && nextTick(function () {
          // 点击 dom 外侧更改群组名称并关闭input
          onClickOutside(nameInputRef.value);
        });
      }
      if (isEdit.value) {
        inputGroupName.value = groupProfile.value.name;
      }
    };
    var clickOutside = false;
    var clickInner = false;
    var onClickOutside = function onClickOutside(component) {
      if (isUniFrameWork) {
        return;
      }
      document.addEventListener("mousedown", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.addEventListener) && (component === null || component === void 0 ? void 0 : component.addEventListener("mousedown", onClickTarget));
    };
    var onClickDocument = function onClickDocument() {
      clickOutside = true;
      if (!clickInner && clickOutside) {
        updateProfile();
        removeClickListener(nameInputRef.value);
      }
      clickOutside = false;
      clickInner = false;
    };
    var onClickTarget = function onClickTarget() {
      clickInner = true;
    };
    var removeClickListener = function removeClickListener(component) {
      document.removeEventListener("mousedown", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.removeEventListener) && (component === null || component === void 0 ? void 0 : component.removeEventListener("mousedown", onClickTarget));
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("label", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u540D\u79F0")), 1), _unref(isEdit) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass([!_unref(isPC) ? 'edit-h5' : ''])
      }, [_createElementVNode("main", null, [!_unref(isPC) ? (_openBlock(), _createElementBlock("header", _hoisted_2, [_createElementVNode("aside", _hoisted_3, [_createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4FEE\u6539\u7FA4\u804A\u540D\u79F0")), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4FEE\u6539\u7FA4\u804A\u540D\u79F0\u540E\uFF0C\u5C06\u5728\u7FA4\u5185\u901A\u77E5\u5176\u4ED6\u6210\u5458")), 1)]), _createElementVNode("span", {
        "class": "close",
        onClick: close
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": "input-box",
        ref_key: "nameInputRef",
        ref: nameInputRef
      }, [_unref(isEdit) ? _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 0,
        "class": "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(inputGroupName) ? inputGroupName.value = $event : null;
        }),
        type: "text",
        onKeyup: _withKeys(updateProfile, ["enter"])
      }, null, 544)), [[_vModelText, _unref(inputGroupName)]]) : _createCommentVNode("", true), !_unref(isPC) ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4EC5\u9650\u4E2D\u6587\u3001\u5B57\u6BCD\u3001\u6570\u5B57\u548C\u4E0B\u5212\u7EBF\uFF0C2-20\u4E2A\u5B57")), 1)) : _createCommentVNode("", true)], 512), !_unref(isPC) ? (_openBlock(), _createElementBlock("footer", _hoisted_5, [_createElementVNode("button", {
        "class": "btn",
        onClick: updateProfile
      }, _toDisplayString(_unref(TUITranslateService).t("\u786E\u8BA4")), 1)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), !_unref(isEdit) || !_unref(isPC) ? (_openBlock(), _createElementBlock("p", {
        key: 1,
        onClick: close
      }, [_createElementVNode("span", null, _toDisplayString(_unref(groupProfile).name), 1), __props.isAuthor ? (_openBlock(), _createBlock(Icon, {
        key: 0,
        file: _unref(editIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
});